import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { Institution } from './institution';
import { InstitutionDialogComponent } from './institution-dialog/institution-dialog.component';

@Component({
    selector: 'kiene-institutionen',
    template: '<kiene-kiene-table [tableDescriptor]="tableDescriptor"></kiene-kiene-table>',
})
export class InstitutionenComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private dialog: MatDialog,
        private api: KieneTableService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Institutionen';
        this.tableDescriptor.uniqueIdentifier = 'Institutionen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'institution/';
        this.tableDescriptor.route = '/lager/lieferanten/institutionen/';
        this.tableDescriptor.nameOfIdField = 'institution_id';
        this.tableDescriptor.searchPlaceholder = 'Name oder Debitor-Nr.';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.addVoid = this.openDialog.bind(this);
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.showDetailsVoid = this.openDialog.bind(this);
        this.tableDescriptor.permissionView = 17201;
        this.tableDescriptor.permissionCreate = 17202;
        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.columns = [
            new TableColumn('bezeichnung', 'Bezeichnung'),
            new TableColumn('institution_art', 'Art'),
            new TableColumn('debitor_konto_nr', 'Debitor'),
            new TableColumn('kreditor_konto_nr', 'Kreditor'),
            new TableColumn('erloes_konto_nr', 'Erlös 86xx'),
            new TableColumn('ort', 'Ort'),
            new KieneBooleanTableColumn('aktiv', 'Aktiv'),
        ];
        this.tableDescriptor.options.push(new TableOption(this.openDialog.bind(this), 'Editieren', 'edit', 17202));
        this.tableDescriptor.options.push(
            new TableOption(this.confirmAndDelete.bind(this), 'Löschen', 'delete', 17204),
        );
        this.tableDescriptor.filterItems.push(new FilterItem('Aktiv', '1', FilterItemType.CHECKBOX, 'aktiv', false));
        this.tableDescriptor.filterItems.push(new FilterItem('Inaktiv', '0', FilterItemType.CHECKBOX, 'aktiv', false));
    }

    openDialog(row?: Institution) {
        const dialogRef = this.dialog.open(InstitutionDialogComponent, {
            width: '720px',
            maxHeight: '90vh',
            data: { institution: row ? { ...row } : null },
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    confirmAndDelete(row: Institution) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            data: { title: 'Institution löschen', text: `${row.bezeichnung || 'Eintrag'} wirklich löschen?` },
        });
        dialogRef.afterClosed().subscribe(ok => {
            if (!ok) {
                return;
            }
            this.api.deleteEntity(this.apiBaseUrl + 'institution/delete.php', row).subscribe({
                next: () => {
                    this.messageService.infoMessage('Institution gelöscht.');
                    this.api.reload();
                },
                error: err => {
                    this.messageService.errorMessage('Institution konnte nicht gelöscht werden.', err);
                    this.api.reload();
                },
            });
        });
    }
}
